import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, Tooltip, makeStyles } from '@material-ui/core'
import DonutLargeIcon from '@material-ui/icons/DonutLargeOutlined'
import BarChartIcon from '@material-ui/icons/BarChartOutlined'
import DashboardIcon from '@material-ui/icons/DashboardOutlined'

// Three-button icon toggle for the allocation tool's chart type.
// Matches the sizing of UtilityPanelToolbar's layout-preset buttons
// so the panel toolbar reads as a single row of peer toggles.
//
// Active state uses the same neutral surface-d2 tint the viewsBtn
// active state uses. No AI theming -- this is a generic utility
// affordance.

const useStyles = makeStyles(() => ({
  row: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2
  },
  button: {
    padding: 5,
    borderRadius: 4,
    border: '1px solid transparent',
    color: 'var(--color-neutral-700, #555)',
    '&:hover': {
      backgroundColor: 'var(--theme-color-surface-d2, #e8e8e8)'
    }
  },
  buttonActive: {
    backgroundColor: 'var(--theme-color-surface-d2, #e8e8e8)',
    color: 'var(--color-neutral-900, #222)'
  },
  icon: {
    fontSize: 16,
    display: 'block'
  }
}))

// Order matters here -- this is the visual order of the buttons.
const OPTIONS = [
  { value: 'donut', label: 'Donut', Icon: DonutLargeIcon },
  { value: 'bar', label: 'Horizontal bar', Icon: BarChartIcon },
  { value: 'treemap', label: 'Treemap', Icon: DashboardIcon }
]

export default function ChartTypeToggle ({ value, onChange }) {
  const classes = useStyles()

  return (
    <div className={classes.row} role='group' aria-label='Chart type'>
      {OPTIONS.map(({ value: optValue, label, Icon }) => {
        const active = value === optValue
        return (
          <Tooltip key={optValue} title={label} placement='bottom' enterDelay={400}>
            <IconButton
              size='small'
              className={`${classes.button} ${active ? classes.buttonActive : ''}`}
              onClick={() => onChange(optValue)}
              aria-label={label}
              aria-pressed={active}
            >
              <Icon className={classes.icon} />
            </IconButton>
          </Tooltip>
        )
      })}
    </div>
  )
}

ChartTypeToggle.propTypes = {
  value: PropTypes.oneOf(['donut', 'bar', 'treemap']),
  onChange: PropTypes.func.isRequired
}
